<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-app
    style="padding:0px;margin: 0px;background: url('./static/eValueRate_Background.png') no-repeat center center fixed;"
    id="app">
    <router-view/>
    <toolbar v-if="!isCRS()"></toolbar>
    <v-footer color="#eaeaea" fixed height="70px" class="hidden-md-and-up" v-if="!isCRS()" style="z-index: 123456789">
      <v-layout
        justify-center
        row
        wrap
      >
        <v-btn
          v-for="link in links"
          :key="link.id"
          color="#004884"
          flat
          round
          small
          class="text-none"
          @click="buttonfooter(link.url)"
        >
          {{ link.text }}
        </v-btn>
        <span v-if="isLogin" class="pt-2">
          {{version}}
        </span>
      </v-layout>
    </v-footer>
    <v-footer color="#eaeaea" fixed height="35px" class="hidden-sm-and-down" v-if="!isCRS()" style="z-index: 123456789">
      <v-layout
        justify-center
        row
        wrap
      >
        <v-btn
          v-for="link in links"
          :key="link.id"
          color="#004884"
          flat
          round
          small
          class="text-none"
          @click="buttonfooter(link.url)"
        >
          {{ link.text }}
        </v-btn>
        <span v-if="isLogin" class="pt-2">
          {{version}}
        </span>
      </v-layout>
    </v-footer>
    <div class="allover" v-if="showIdle">
      <v-layout row>
        <Idle :idleMessage="idleMessage">
        </Idle>
      </v-layout>

      <!--<SelfBuildingSquareSpinner></SelfBuildingSquareSpinner>-->
      <!--
      <div class="hollow-dots-spinner" :style="spinnerStyle">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
      -->
    </div>
  </v-app>
</template>

<script>
  import toolbar from '@/components/Toolbar.vue'
  import Idle from '@/components/widgets/Idle.vue'
  import {SelfBuildingSquareSpinner} from 'epic-spinners'
  // import { HalfCircleSpinner } from 'epic-spinners'
  import Vue from 'vue';
  import $ from 'jquery'

  export default {
    name: 'App',
    components: {Idle, toolbar, SelfBuildingSquareSpinner}, //  HalfCircleSpinner
    data: () => ({
      isLogin: true,
      showIdle: false,
      spinnerStyle: '',
      idleMessage: false,
      isResizeDirtyTm: 0,
      idleStart: 0,
      isResizeDirty: false,
      resizeInit: false,
      version: 'vvv',
      links: [
        {
          id: 0,
          text: Vue.i18n.translate('FOOTER_MAILADDRESS'),
          url: 'mailto:' + Vue.i18n.translate('FOOTER_MAILADDRESS'),
        }, {
          id: 2,
          text: Vue.i18n.translate('FOOTER_LEGAL_NOTICE'),
          url: Vue.i18n.translate('FOOTER_LEGAL_NOTICE_URL')
        }, {
          id: 3,
          text: Vue.i18n.translate('FOOTER_DATA_PRIVACY'),
          url: Vue.i18n.translate('FOOTER_DATA_PRIVACY_URL')
        }
      ]
    }),
    methods: {
      buttonfooter: function (url) {
        window.open(url), '_blank'
      },
      isCRS() {
        return Vue.prototype.$config.IS_CRS
      },
      OnShowIdle(show) {
        this.idleMessage = false
        if (!this.showIdle) {
          this.idleStart = new Date().getTime()
        }
        this.showIdle = show
        if (show.message) {
          this.idleMessage = show.message
        }
        this.checkDiffMessage()
      },
      checkDiffMessage() {
        if (this.showIdle) {
          var diff = new Date().getTime() - this.idleStart
          if (diff > 2000) {
            this.idleMessage = Vue.i18n.translate('IDLE_MESSAGE_BIG_DATA')
          }
          window.setTimeout(this.checkDiffMessage, 500)
        }
      },
      onLogin(login) {
        this.isLogin = !login
      },
      OnGetModuleTitle(title) {
        // this.showBackBtn = title !== ''
      },
      OnSetLocale() {
        this.links = [
          {
            id: 0,
            text: Vue.i18n.translate('FOOTER_MAILADDRESS'),
            url: 'mailto:' + Vue.i18n.translate('FOOTER_MAILADDRESS'),
          }, {
            id: 2,
            text: Vue.i18n.translate('FOOTER_LEGAL_NOTICE'),
            url: Vue.i18n.translate('FOOTER_LEGAL_NOTICE_URL')
          }, {
            id: 3,
            text: Vue.i18n.translate('FOOTER_DATA_PRIVACY'),
            url: Vue.i18n.translate('FOOTER_DATA_PRIVACY_URL')
          }
        ]
        Vue.prototype.$api.reloadModule()
      },
      checkResize() {
        var cmp = this
        if (!this.resizeInit) {
          if ($(window).resize) {
            this.resizeInit = true
            $(window).resize(function () {
              cmp.isResizeDirtyTm = new Date().getTime()
              if (!cmp.isResizeDirty) {
                cmp.isResizeDirty = true
              }
            })
          }
          window.setTimeout(cmp.checkResize, 1000)
          return
        }
        if (this.isResizeDirty) {
          var diff = new Date().getTime() - this.isResizeDirtyTm
          if (diff > 900) {
            Vue.prototype.$eventHub.$emit('OnResize', {})
            this.isResizeDirty = false
          } else {
            this.isResizeDirtyTm = new Date().getTime()
          }
        }
        window.setTimeout(this.checkResize, 1000)
      }
    },
    mounted() {
      this.version = Vue.prototype.$config.VERSION
      // this.idleMessage = Vue.i18n.translate('IDLE_MESSAGE_BIG_DATA')
      window.$('#myToolbar').removeClass('scrollerOn')
      window.$('#myToolbar').addClass('scrollerOff')
      window.$(document).scroll(function (a, b, c) {
        if (window.$(window).scrollTop() > 40) {
          window.$('#myToolbar').removeClass('scrollerOff')
          window.$('#myToolbar').addClass('scrollerOn')
        } else if (window.$(window).scrollTop() < 40) {
          window.$('#myToolbar').removeClass('scrollerOn')
          window.$('#myToolbar').addClass('scrollerOff')
        }
      })
    },
    created() {
      var cmp = this
      window.setTimeout(cmp.checkResize, 1000)
      Vue.prototype.$eventHub.$on('OnLogin', this.onLogin)
      Vue.prototype.$eventHub.$on('OnShowIdle', this.OnShowIdle)
      Vue.prototype.$eventHub.$on('OnGetModuleTitle', this.OnGetModuleTitle)
      Vue.prototype.$eventHub.$on('setLocale', this.OnSetLocale)

    },
    destroyed() {
      Vue.prototype.$eventHub.$off('OnLogin', this.onLogin)
      Vue.prototype.$eventHub.$off('OnShowIdle', this.OnShowIdle)
      Vue.prototype.$eventHub.$off('OnGetModuleTitle', this.OnGetModuleTitle)
      Vue.prototype.$eventHub.$off('setLocale', this.OnSetLocale)
    }
  }
</script>

<style>
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }

  .idleMessage {
    color: #004884;
    font-size: medium;
    width: 200px;
    text-align: center;
    display: inline-block;
    background-color: white;
    margin-top: 20%;
    z-index: 1111111;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue